import { SetStateAction, useState } from "react";
import SelectDropdown from "../../common/DropDown";
import { useTranslation } from "react-i18next";

const GraphViewSelector = ({ onChange }) => {
    const { t } = useTranslation('profit_and_loss');

    const graphOptions = [
        { label: t('income'), value: "income" },
        { label: t('directCosts'), value: "directCosts" },
        { label: t('operatingCosts'), value: "operatingCosts" },
    ];

    const [viewMode, setViewMode] = useState("income");

    const handleChange = (selected: SetStateAction<string>) => {
        setViewMode(selected);
        onChange?.(selected);
    };

    return (
        <SelectDropdown
            value={viewMode}
            onChange={handleChange}
            options={graphOptions}
            className="w-[200px]"
            placeholder="Select view"
        />
    );
};

export default GraphViewSelector;